import { FaTimes } from 'react-icons/fa';

export const ColorsSwatch = props => {
  const { onClick, colors, currentColor } = props;
  return (
    <div className='flex gap-05 flex-wrap items-center'>
      {colors.map(color => (
        <div
          key={color}
          onClick={() => onClick(color)}
          style={{ height: 21 }}
          className={`cursor-pointer transition hover:bg-opacity-50 bg-${color} ${
            color === 'transparent' ? '' : 'p-07'
          } rounded-full border-contrast  ${
            currentColor === color ? 'border-2' : 'border-t'
          }`}
        >
          {color === 'transparent' && <FaTimes className='text-contrast' />}
        </div>
      ))}
    </div>
  );
};
